import { Truck } from "lucide-react";
import { tl } from "@/lib/format";
import { useStore } from "@/context/StoreContext";

export const FreeShippingBar = ({ testId = "free-shipping-bar" }) => {
  const { quote, localSubtotal, settings } = useStore();
  const threshold = quote?.free_shipping_threshold ?? settings?.free_shipping_threshold ?? 3000;
  const current = quote?.products_total ?? localSubtotal;
  const remaining = Math.max(0, threshold - current);
  const pct = Math.min(100, (current / threshold) * 100);
  return (
    <div data-testid={testId} className="rounded-lg bg-muted/60 p-4">
      <div className="mb-2 flex items-center gap-2 text-sm">
        <Truck className="h-4 w-4 text-accent" />
        {remaining > 0 ? (
          <span data-testid={`${testId}-text`}>
            Ücretsiz kargo için <b className="text-accent">{tl(remaining)}</b> daha ekleyin
          </span>
        ) : (
          <span data-testid={`${testId}-text`} className="font-medium text-primary">Tebrikler! Kargonuz ücretsiz.</span>
        )}
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-border">
        <div className="h-full rounded-full bg-accent" style={{ width: `${pct}%`, transition: "width 0.4s ease" }} />
      </div>
    </div>
  );
};
